import {motion} from "framer-motion";
import React from "react";


function TransitionLoader(){

    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100">
            <motion.div 
                className="loading"
                key="loading"
                initial={{opacity: 0.05, scale: 1}}
                animate={{opacity: 1, scale: 1}}
                transition={{duration: 0.75, ease: "easeIn"}}
                exit={{opacity: 0.1, y: 0, transition: {duration: 0.3, ease: "easeOut"}}}
            >
                <div className="d-flex justify-content-center align-items-center">
                    <p className="fs-5 mb-0">Loading...</p>
                </div>
            </motion.div>
        </div>
    )
}

export default TransitionLoader